import React from 'react';
import './SecurityCheckComponent.less';
import {LoadingOverlay} from '@homeaway/react-loading-overlay';
import {TrackingContext} from '@homeaway/react-event-tracking';
import mfaClient from '../../util/mfaClient';
import aamClient from '../../util/aamClient';

class SecurityCheckComponent extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.shouldChallenge();
    }

    shouldChallenge = () => {
        const {updatePage, handleError} = this.props;
        let riskDevices = aamClient.getDevices();
        let shouldChallengePromise = mfaClient.shouldChallenge(riskDevices);
        shouldChallengePromise
            .then(this.processChallengeType)
            .catch((error) => {
                if (error.status === 403) {
                    this.context.trigger('generic.event', {eventaction: 'mfa.shouldChallenge.failed.accountblocked', eventcategory: 'lex', eventlabel: 'ums'});
                    updatePage('accountblocked');
                } else {
                    this.context.trigger('generic.event', {eventaction: 'mfa.shouldChallenge.failed.servicefailure', eventcategory: 'lex', eventlabel: 'ums'});
                    handleError(this.props.lingua.read('error.generic'), '');
                }
            });
    };

    redirectToPOB = () => {
        let hostPath = (typeof window !== 'undefined') && (typeof window.location !== 'undefined') && (typeof window.location.origin) !== 'undefined' ?
            window.location.origin :
            'http://localhost:8080';
        const configUrl = `${hostPath}/p/account-settings/security`;
        window.location.assign(configUrl);
    };

    processChallengeType = (parsedJson) => {
        const {lingua, onClose, handleError} = this.props;
        switch (parsedJson.challengeType) {
            case 'COMPLETE':
                this.context.trigger('generic.event', {eventaction: 'mfa.shouldChallenge.complete', eventcategory: 'lex', eventlabel: 'ums'});
                onClose();
                break;
            case 'SETUP_2FA':
            case 'SETUP_SQ':
                this.context.trigger('generic.event', {eventaction: 'mfa.shouldChallenge.setup', eventcategory: 'lex', eventlabel: 'ums'});
                this.redirectToPOB();
                break;
            case 'CHALLENGE_2FA':
                this.context.trigger('generic.event', {eventaction: 'mfa.shouldChallenge.challenge', eventcategory: 'lex', eventlabel: 'ums'});
                this.startChallenge(parsedJson);
                break;
            default:
                this.context.trigger('generic.event', {eventaction: 'mfa.shouldChallenge.unknownmfastate', eventcategory: 'lex', eventlabel: 'ums'});
                handleError(lingua.read('error.generic'), '');
        }
    };

    startChallenge = (parsedJson) => {
        this.props.startChallengeProcess(parsedJson.challengeTicket);
    };

    render() {
        return (
            <>
                <p className="SecurityLabel">{this.props.lingua.read('lex.owner.check.security')}</p>
                <div className="Overlay" >
                    <LoadingOverlay loading/>
                </div>
            </>
        );
    }
}

SecurityCheckComponent.contextType = TrackingContext;
export default SecurityCheckComponent;
